/* import __COLOCATED_TEMPLATE__ from './sh-select.hbs'; */
import clsx from 'clsx';
import Component from '@glimmer/component';
import { createCache, getValue } from '@glimmer/tracking/primitives/cache';

const CLASS_NAME = 'sh-select';
const CLASS_NAME_ACTIVE = `${CLASS_NAME}--active`;
const CLASS_NAME_DISABLED = `${CLASS_NAME}--disabled`;

class ShSelect extends Component {
  #cache = createCache(() => {
    const { value, options } = this.args;

    if (value != null) {
      for (let i = 0; i < options.length; i++) {
        if (`${options[i].value}` === `${value}`) {
          return i;
        }
      }
    }

    return -1;
  });

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.selectedIndex > -1 && CLASS_NAME_ACTIVE,
      this.args.disabled && CLASS_NAME_DISABLED,
    );
  }

  get selectedIndex() {
    return getValue(this.#cache);
  }
}

export default ShSelect;
